<template>
  <form>
    <!-- NAME -->
    <!-- <div class="input-and-label">
          <label for="inventoryModalName" class="input-label">Име</label>
          <div class="input-wrapper" :class="{ invalid: !isNameValid }">
            <span class="mck">O</span>
            <input
              id="inventoryModalName"
              type="text"
              placeholder="Име"
              v-model="inventory.name"
              @keyup="isNameValid = true"
              @keydown.enter.prevent
            />
          </div>
        </div> 
         <div class="input-and-label">
          <label for="inventoryBrand" class="input-label">Марка/Модел</label>
          <div class="input-wrapper">
            <span class="mck">O</span>
            <input
              id="inventoryBrand"
              type="text"
              placeholder="Марка/Модел"
              v-model="inventory.brand"
              @keydown.enter.prevent
            />
          </div>
        </div>
         <div class="input-and-label">
          <label for="inventorySerialNumber" class="input-label"
            >Сериен номер</label
          >
          <div class="input-wrapper">
            <span class="mck">O</span>
            <input
              id="inventorySerialNumber"
              type="text"
              placeholder="Сериен номер"
              v-model="inventory.serialNumber"
              @keydown.enter.prevent
            />
          </div>
        </div>
       <div class="input-and-label" v-if="type !== 'user_inventory'">
          <label for="inventoryModalName" class="input-label"
            >Часова ставка</label
          >
          <div class="input-wrapper">
            <span class="mck">O</span>
            <input
              id="inventoryHourlyRate"
              type="text"
              placeholder="Часова ставка"
              v-model="inventory.hourlyRate"
              @keydown.enter.prevent
            />
          </div>
        </div>
        <div class="input-and-label">
          <label for="inventoryModalName" class="input-label">Забележка</label>
          <div class="input-wrapper">
            <span class="mck">O</span>
            <input
              id="inventoryModalName"
              type="text"
              placeholder="Забележка"
              v-model="inventory.note"
              @keydown.enter.prevent
            />
          </div>
        </div> -->

    <TheInput
      :dark="true"
      placeholder="Име"
      label="Име"
      :invalid="!isNameValid"
      :disabled="isChild"
      icon="O"
      :value="isChild ? getParentField('name') : inventory.name"
      @input="(inventory.name = $event), (isNameValid = true)"
    />

    <TheInput
      :dark="true"
      placeholder="Марка/Модел"
      label="Марка/Модел"
      :disabled="isChild"
      icon="O"
      :value="isChild ? getParentField('brand') : inventory.brand"
      @input="inventory.brand = $event"
    />

    <TheInput
      :dark="true"
      placeholder="Сериен номер"
      label="Сериен номер"
      :disabled="isChild"
      icon="O"
      :value="isChild ? getParentField('serialNumber') : inventory.serialNumber"
      @input="inventory.serialNumber = $event"
    />

    <TheInput
      v-if="type !== 'user_inventory' && !isChild"
      :dark="true"
      :digitsOnly="true"
      placeholder="Часова ставка, €"
      label="Часова ставка, €"
      icon="O"
      v-model="inventory.hourlyRate"
    />

    <template v-if="isChild && inventory.serviceInfo">
      <TheInput
        :dark="true"
        placeholder="Кратко описание"
        label="КРАТКО ОПИСАНИЕ"
        icon="O"
        v-model="inventory.description"
      />

      <TheInput
        :dark="true"
        label="КИЛОМЕТРИ (ПРИ ВСЯКА ПРОМЯНА СЕ ДОБАВЯ ДАТА)"
        placeholder="Километри"
        icon="O"
        :digitsOnly="true"
        v-model="inventory.serviceInfo.km"
      />

      <TheInput
        :dark="true"
        label="МОТОЧАСОВЕ (ПРИ ВСЯКА ПРОМЯНА СЕ ДОБАВЯ ДАТА)"
        placeholder="Моточасове"
        icon="O"
        :digitsOnly="true"
        v-model="inventory.serviceInfo.mh"
      />
    </template>
    <TheInput
      :dark="true"
      placeholder="Забележка"
      label="Забележка"
      :disabled="isChild"
      icon="O"
      :value="isChild ? getParentField('note') : inventory.note"
      @input="inventory.note = $event"
    />

    <template v-if="!isChild">
      <hr />
      <label class="input-label">Текущ статус</label>
      <!-- PERMISSIONS -->
      <div class="medium-modal-permissions">
        <TheInput
          type="checkbox"
          label="Свободен"
          :value="!inventory.status"
          @change="handleStatusCheckboxChange($event, '')"
        />
        <TheInput
          type="checkbox"
          title="Този статус се получава автоматично, когато на инвентара се избере локация"
          label="На обект"
          :disabled="true"
          :value="inventory.status === 'onsite'"
        />
        <TheInput
          type="checkbox"
          label="За ремонт"
          :value="inventory.status === 'repair'"
          @change="handleStatusCheckboxChange($event, 'repair')"
        />
        <TheInput
          type="checkbox"
          label="За брак"
          :value="inventory.status === 'scrap'"
          @change="handleStatusCheckboxChange($event, 'scrap')"
        />
        <TheInput
          type="checkbox"
          label="Липсва"
          :value="inventory.status === 'missing'"
          @change="handleStatusCheckboxChange($event, 'missing')"
        />

        <!-- <label class="checkbox-wrapper">
        Свободен
        <input
          type="checkbox"
          :checked="!inventory.status"
          @change="handleStatusCheckboxChange($event, '')"
        />
        <span class="checkmark"></span>
      </label> 
       <label
        class="checkbox-wrapper"
        title="Този статус се получава автоматично, когато на инвентара се избере локация"
      >
        На обект
        <input
          type="checkbox"
          :checked="inventory.status === 'onsite'"
          disabled="true"
        />
        <span class="checkmark"></span>
      </label>
      <label class="checkbox-wrapper">
        За ремонт
        <input
          type="checkbox"
          :checked="inventory.status === 'repair'"
          @change="handleStatusCheckboxChange($event, 'repair')"
        />
        <span class="checkmark"></span>
      </label>  
      <label class="checkbox-wrapper">
        За брак
        <input
          type="checkbox"
          :checked="inventory.status === 'scrap'"
          @change="handleStatusCheckboxChange($event, 'scrap')"
        />
        <span class="checkmark"></span>
      </label>
      <label class="checkbox-wrapper">
        Липсва
        <input
          type="checkbox"
          :checked="inventory.status === 'missing'"
          @change="handleStatusCheckboxChange($event, 'missing')"
        />
        <span class="checkmark"></span>
      </label>-->
      </div>
    </template>
    <template v-else>
      <section class="inventory-files">
        <h1>ДОКУМЕНТАЦИЯ</h1>

        <section class="files-wrapper">
          <div
            class="file"
            v-for="(file, index) of inventory.files"
            :key="index"
          >
            <p>{{ file.name }}</p>
          </div>
        </section>

        <div @click="clickFileInput()" class="add">
          <span class="mck">L</span>
          <p>Добавяне на документи към този инвентар</p>
        </div>

        <span class="info"
          >(Качените документи могат да бъдат свалени или изтрити от менюто
          Действия > Виж документацията)</span
        >
      </section>

      <input
        type="file"
        :multiple="true"
        name="file"
        class="file-input"
        @change="handleFiles($event.target.files)"
        ref="fileInput"
      />
    </template>
  </form>
</template>

<script>
import TheInput from "@/components/TheInput.vue";
export default {
  props: ["inventory", "type"],
  components: { TheInput },
  computed: {
    isChild() {
      return ["car", "heavy_machinery"].includes(this.type);
    },
  },
  data() {
    return {
      isNameValid: true,
    };
  },
  methods: {
    getParentField(field) {
      if (this.inventory.parent) {
        return this.inventory.parent[field];
      } else return "";
    },
    clickFileInput() {
      this.$refs["fileInput"].click();
    },
    handleFiles(files) {
      let invFiles = [];
      let totalFilesSize = 0;
      let maxFilesSize = 10 * 1024 * 1024; // 10 mb

      for (let file of files) {
        totalFilesSize += Number(file.size);

        // stops adding files if the maxSize has been reached
        if (totalFilesSize > maxFilesSize) {
          this.$snotify.warning(
            "Не може да качвате файлове повече от 10 мб, изберете по-малко"
          );
          invFiles = [];
          return;
        } else {
          invFiles.push(file);
        }
      }

      this.inventory.files = invFiles;
    },
    handleStatusCheckboxChange(event, value) {
      if (event) this.inventory.status = value;
      else this.inventory.status = "";
    },
  },
};
</script>

<style scoped lang="scss">
.medium-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.inventory-files {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 10px 0;

  .files-wrapper {
    max-height: 70px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .file {
      align-items: center;
      background: #e9e9e9;
      border-radius: 4px;
      display: flex;
      padding: 5px;
      gap: 5px;
      justify-content: space-between;

      .mck {
        cursor: pointer;
        font-size: 16px;
      }
    }
  }

  h1 {
    font-size: 12px;
  }
  .info {
    font-size: 12px;
    opacity: 0.5;
  }
}
.file-input {
  cursor: pointer;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  width: 1px;
}
hr {
  border: 0;
  background-color: #707070;
  height: 1px;
  opacity: 0.2;
  margin: 20px 0 10px;
}
/* Responsive */
@media screen and (max-width: 900px) {
  .medium-modal {
    width: 90%;
  }
}
@media screen and (max-height: 550px) {
  .medium-modal {
    height: 100%;
  }
}
</style>
